import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import GuestLayout from "../../Layouts/GuestLayout";
import { Button } from '../../shadcn/ui/button';

export default function Verify2FA() {
  const { user, validate2FA, send2FAQRCode } = useAuth();
  const [otp, setOtp] = useState(new Array(6).fill("")); // Six empty slots for OTP
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  console.log(user);
    // if (user && !user.two_factor_enabled && !user.two_factor_verified) {
    //   return <Navigate to="/setup-2fa" replace />;
    // }

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    if (value) {
      // Add the value to the current index
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input if available
      if (index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    } else {
      // If the value is empty, clear the current field and move to the previous input
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const otpValue = otp.join(""); // Combine OTP array into a single string
    try {
      await validate2FA(otpValue);
      navigate("/"); // Redirect to dashboard after successful verification
    } catch (err) {
      setError("Μη έγκυρο OTP. Δοκιμάστε ξανά.");
    }
  };

  const handleSendQRCode = async () => {
    setError("");
    setSuccess("");
    try {
      const message = await send2FAQRCode(user.email);
      setSuccess(message);
    } catch (err) {
      setError("Αποτυχία αποστολής του κωδικού QR μέσω email. Δοκιμάστε ξανά.");
    }
  };

  return (
    <GuestLayout>
      <div className="flex flex-col items-center justify-center h-screen">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-md bg-white p-6 rounded shadow-md"
        >
          <h1 className="text-2xl mb-4">Επαλήθευση δύο παραγόντων</h1>
          {error && <div className="text-red-500 mb-4">{error}</div>}
          {success && <div className="text-green-500 mb-4">{success}</div>}

          {/* OTP Input */}
          <div className="flex justify-center gap-2 mb-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                className="w-12 h-12 text-center border rounded text-lg"
                onKeyDown={(e) => {
                  if (e.key === "Backspace" && !otp[index] && index > 0) {
                    document.getElementById(`otp-input-${index - 1}`).focus();
                  }
                }}
              />
            ))}
          </div>

          {/* Verify Button */}
          <Button
            type="submit"
            className="w-full mb-2 text-white"
          >
            Επαληθεύω
          </Button>

          {/* Resend QR Code Button */}
          <Button
            type="button"
            onClick={handleSendQRCode}
            className="w-full bg-gray-500 text-white"
          >
            Στείλτε ξανά τον κωδικό QR στο email
          </Button>
        </form>
      </div>
    </GuestLayout>
  );
}
